import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames/bind';

import Type from '../Typography';
import styles from './MenuItem.less';
import { getRef } from '../utils';

const cxb = cx.bind(styles);

/**
 * **Access:**
 * ```js
 * import { Flyouts } from '@iss/client-react-components'
 *
 * <Flyouts.MenuItem/>
 * ```
 *
 *
 */
export default class MenuItem extends React.PureComponent {
  static propTypes = {
    condensed: PropTypes.bool,
    selected: PropTypes.bool,

    kind: PropTypes.oneOf(['light', 'dark', 'special', 'special-dark']).isRequired,
  };

  static defaultProps = {
    kind: 'light',
  };

  ref = React.createRef();

  getDOMNode() {
    return getRef(this);
  }

  componentDidUpdate(prevProps, prevState) {
    /* istanbul ignore else */
    if (this.props.selected !== prevProps.selected) {
      this.focus();
    }
  }

  focus() {
    const {
      ref: { current },
    } = this;

    current.getDOMNode().focus();
  }

  render() {
    const { className, condensed, kind, selected, ...props } = this.props;
    const tag = props.as ? props.as : props.href ? 'a' : 'button';

    return (
      <Type {...props} ref={this.ref} as={tag} className={cxb('item', kind, className, { selected, condensed })} />
    );
  }
}
